import React from 'react';
import {
  Box,
  forwardRef,
  Stack,
  SystemCSSProperties,
} from '@cardboard-ui/react';
import { BoxProps } from '@cardboard-ui/react';
import useSafeAreaInsetStyle from 'hooks/useSafeAreaInsetStyle';

interface ScreenProps extends Pick<BoxProps, 'sx' | 'bg'> {
  bar: React.ReactNode;
  mobileFlex?: boolean;
}
export const ScreenWithBar = forwardRef<ScreenProps, 'div'>(
  ({ children, bar: bars, mobileFlex, ...props }, ref) => {
    const extractedBgColor =
      props.sx &&
      (props.sx['--bar-bg' as keyof SystemCSSProperties] as string | null);

    useSafeAreaInsetStyle('top', { backgroundColor: extractedBgColor || '' });

    return (
      <Box
        ref={ref}
        w="100%"
        h="100%"
        display="flex"
        flexDirection="column"
        overflow="hidden"
        {...props}
      >
        {bars && (
          <Stack
            spacing={0}
            overflow="hidden"
            style={{
              fontWeight: '700',
            }}
            bg="var(--bar-bg)"
            color="var(--bar-color)"
          >
            {React.Children.map(bars, (bar) => (
              <Box overflow="hidden">{bar}</Box>
            ))}
          </Stack>
        )}
        <Box
          flex="1"
          overflow="auto"
          {...(mobileFlex ? { display: 'flex' } : { position: 'relative' })}
        >
          {children}
        </Box>
      </Box>
    );
  },
);
